import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { BASE_URL } from '../config/api';

const EditPurcheshReturn = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    
    const [staffId, setStaffId] = useState('');
    const [vepariId, setVepariId] = useState('');
    const [pcsWeight, setPcsWeight] = useState('');
    const [price, setPrice] = useState('');
    const [total, setTotal] = useState('');
    const [image, setImage] = useState(null);

    useEffect(() => {
        fetch(`${BASE_URL}purcheshreturns/${id}`)
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    const { staff_id, vepari_id, pcs_weight, price, total, image } = data.data;
                    setStaffId(staff_id);
                    setVepariId(vepari_id);
                    setPcsWeight(pcs_weight);
                    setPrice(price);
                    setTotal(total);
                    setImage(image);
                } else {
                    alert('Failed to fetch purchase return data');
                }
            })
            .catch(error => console.error('Error fetching data:', error));
    }, [id]);

    const handleFileChange = (event) => {
        setImage(event.target.files[0]);
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const formData = new FormData();
        formData.append('staff_id', staffId);
        formData.append('vepari_id', vepariId);
        formData.append('pcs_weight', pcsWeight);
        formData.append('price', price);
        formData.append('total', total);
        if (image) {
            formData.append('image', image);
        }

        fetch(`${BASE_URL}purcheshreturns/${id}`, {
            method: 'PUT',
            body: formData,
        })
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    alert('Purchesh return entry updated successfully');
                    navigate('/PurcheshReturnsList');
                } else {
                    alert('Failed to update purchase return');
                }
            })
            .catch(error => {
                console.error('Error updating purchase return:', error);
                alert('An error occurred');
            });
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <h3>Edit Purchesh Return</h3>
            </div>

            <section className="section">
                <div className="row" id="basic-table">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4>Edit Purchesh Return</h4>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label htmlFor="staffId" className="form-label">Staff ID</label>
                                            <input
                                                type="text"
                                                id="staffId"
                                                className="form-control"
                                                value={staffId}
                                                onChange={(e) => setStaffId(e.target.value)}
                                                required
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label htmlFor="vepariId" className="form-label">Vepari ID</label>
                                            <input
                                                type="text"
                                                id="vepariId"
                                                className="form-control"
                                                value={vepariId}
                                                onChange={(e) => setVepariId(e.target.value)}
                                                required
                                            />
                                        </div>
                                    </div>

                                    <div className="row mt-3">
                                        <div className="col-md-6">
                                            <label htmlFor="pcsWeight" className="form-label">PCS Weight</label>
                                            <input
                                                type="text"
                                                id="pcsWeight"
                                                className="form-control"
                                                value={pcsWeight}
                                                onChange={(e) => setPcsWeight(e.target.value)}
                                                required
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label htmlFor="price" className="form-label">Price</label>
                                            <input
                                                type="text"
                                                id="price"
                                                className="form-control"
                                                value={price}
                                                onChange={(e) => setPrice(e.target.value)}
                                                required
                                            />
                                        </div>
                                    </div>

                                    <div className="row mt-3">
                                        <div className="col-md-6">
                                            <label htmlFor="total" className="form-label">Total</label>
                                            <input
                                                type="text"
                                                id="total"
                                                className="form-control"
                                                value={total}
                                                onChange={(e) => setTotal(e.target.value)}
                                                required
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label htmlFor="image" className="form-label">Image</label>
                                            <input
                                                type="file"
                                                id="image"
                                                className="form-control"
                                                onChange={handleFileChange}
                                            />
                                        </div>
                                    </div>

                                    <div className="row mt-3">
                                        <div className="col-md-12 text-end">
                                            <button type="submit" className="btn btn-primary">Submit</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default EditPurcheshReturn;
